import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'tech-stack-anniversary',
  template: require('./tech-stack-anniversary.component.html'),
  styles: [require('./../blog.component.scss'), require('./tech-stack-anniversary.component.scss')]
})
export class TechStackAnniversaryComponent extends BlogPage {
  title = "Linescape Anniversary with new Tech Stack - Linescape";
  description = "Leading Sailing Schedules provider migrates systems and components to new equipment and to the cloud.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/tech-stack-anniversary/tech-stack-anniversary.component.ts